module.exports = __webpack_public_path__ + "img/Outside_thumbnail.958fdfe1.webp";